import { useQueryInbox } from '../../../connections/queries/useQueryInbox.js';
import { getResourcePermissionsByRole } from '../../../permission/utils/getResourcePermissionsByRole.js';
import { useQuerySpaceOrFolderById } from '../../queries/useQuerySpaceOrFolderById.js';
import { useRouter } from '@fabric-app/compat';
import { useMemo } from 'react';
import { getRouteParamAsString } from '@fabric-app/utils/url/routing';

const canSaveToTargetFolderSpace = (target) => {
  if (!target) return false;
  const perm = target.type === "folder" ? target.data.permission : target.data.folder.permissions;
  const permissions = getResourcePermissionsByRole(perm);
  return permissions.childResources.create.allowed;
};
const useDestinationParentFolderFromPathname = () => {
  const router = useRouter();
  const [listId, folderId] = getRouteParamAsString(router.query, [
    "listId",
    "folderId"
  ]);
  const { inboxRoot } = useQueryInbox();
  const parentOrSpace = useQuerySpaceOrFolderById(listId || folderId || void 0);
  const possibleParentFolder = listId || folderId ? parentOrSpace : void 0;
  return useMemo(() => {
    const canSave = possibleParentFolder && canSaveToTargetFolderSpace(possibleParentFolder);
    if (canSave) {
      return {
        id: possibleParentFolder.id,
        name: possibleParentFolder.name || "Untitled"
      };
    } else {
      return {
        id: inboxRoot?.id || "@alias::inbox",
        name: "Inbox"
      };
    }
  }, [
    possibleParentFolder,
    inboxRoot
  ]);
};

export { useDestinationParentFolderFromPathname };
//# sourceMappingURL=useDestinationParentFolderFromPathname.js.map
